<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";
import * as categoryService from '../../../components/service/category.service';

export default {
  props: {
    item_key: {
      type: String,
      required: false,
    },
    item_value: {
      // type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    submitted: {
      type: Boolean,
      required: false,
    },
    validation: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true
    }
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: null,
      options: [],
      label: {
        label: 'Select Location',
        placeholder: 'Select Location'
      }
    };
  },
  watch: {
    value(val) {
        this.updateValue(val.id)
    },
  },
  methods: {
    async getOptions() {
      let filter = {
        "where": {
          "name": "Locations",
          "cmsId": this.$route.params.cmsId
        },
        "include": [
          {
            "relation": "pages"
          }
        ]
      };

      filter = encodeURIComponent(JSON.stringify(filter));
      
      let data = await categoryService.getWithFilter(filter)
      let pages = data[0].pages
      this.options = pages;
      if(this.options && this.options.length) this.value = this.options[0]
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
<template>
  <div>
    <Label :item="label"/>
    <multiselect
      track-by="title"
      label="title"
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="'Select Location'"
      :allow-empty="false"
      :preselectFirst="true"
      open-direction="bottom"
    >
      <template slot="singleLabel" slot-scope="{ option }"
        ><strong>{{ option.title }}</strong></template
      >
    </multiselect>
  </div>
</template>



